var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTmtIcon = function SvgTmtIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 19.503h-3.5v-13H25a1 1 0 1 0 0-2h-3.5v-3.5a1 1 0 0 0-2 0v3.5h-13v-3.5a1 1 0 0 0-2 0v3.5H1a1 1 0 0 0 0 2h3.5v13H1a1 1 0 0 0 0 2h3.5v3.5a1 1 0 1 0 2 0v-3.5h13v3.5a1 1 0 1 0 2 0v-3.5H25a1 1 0 1 0 0-2ZM14.079 16.37a.756.756 0 0 1-.815.827.744.744 0 0 1-.8-.827v-5.41l-.768.337a.9.9 0 0 1-.372.084.753.753 0 0 1-.743-.768.74.74 0 0 1 .5-.708l1.8-.815c.134-.056.275-.09.42-.1a.8.8 0 0 1 .779.815l-.001 6.565Z",
    fill: "#fff"
  })));
};
export default SvgTmtIcon;